import * as API from '@/api/app'
import request from './appRequest'
import { APP_STR } from '@/config/app'

//获取新版app信息
export function getInfo() {
    return request.get(API.DOWN_INFO, {
        params: {
            appstr: APP_STR
        }
    })
}
